// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  UserPriceJudgement,
} from "./types";

export const params = {
  underwritableEntityId: __t.uuid(),
  targetablePropertyId: __t.uuid(),
  comparablePropertyIds: __t.array(__t.uuid()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
};
export const returnType = __t.unit()